import { Leaf, ShieldCheck, Sparkles, HeartHandshake } from "lucide-react";
import demo from "../assests/heropage.png";

const AboutCeliora = () => {
  return (
    <section className="bg-[#FAF7F3] text-[#1F1B18]">

      {/* Hero */}

      <div className="relative h-[75vh] overflow-hidden">

        <img
          src={demo}
          alt=""
          className="absolute inset-0 w-full h-full object-cover brightness-75"
        />

        {/* <div className="absolute inset-0 bg-black/20" /> */}

        <div className="relative z-10 max-w-7xl mx-auto h-full flex items-center px-6">

          <div className="max-w-2xl text-black">

            <p className="uppercase tracking-[4px] text-sm mb-4">
              About Celiora
            </p>

            <h1 className="text-6xl font-heading leading-tight">

              Seoul Inspired.
              <br />
              Crafted For Indian Skin.

            </h1>

            <p className="mt-8 text-lg leading-8 text-black/90">

              Combining advanced Korean skincare science with formulas
              thoughtfully designed for Indian skin, Celiora delivers
              everyday luxury with visible results.

            </p>

          </div>

        </div>

      </div>

      {/* Story */}

      <section className="max-w-7xl mx-auto py-28 px-6 grid lg:grid-cols-2 gap-20 items-center">

        <div>

          <span className="tracking-[4px] uppercase text-sm text-[#9D7D4F]">

            Our Story

          </span>

          <h2 className="text-5xl font-heading mt-5">

            Beauty Rooted In
            Simplicity.

          </h2>

          <p className="mt-8 leading-8 text-gray-600">

            Celiora was born from a simple vision—to bring the elegance,
            innovation and effectiveness of Korean skincare to Indian
            consumers.

            Every formula blends powerful ingredients with lightweight
            textures that nourish, repair and protect your skin every day.

          </p>

        </div>

        <img
          src={demo}
          alt=""
          className="rounded-3xl shadow-xl"
        />

      </section>

      {/* Philosophy */}

      <section className="bg-white py-24">

        <div className="max-w-7xl mx-auto px-6 text-center">

          <span className="uppercase tracking-[4px] text-[#9D7D4F]">

            Our Philosophy

          </span>

          <h2 className="font-heading text-5xl mt-5">

            Healthy Skin.
            Timeless Beauty.

          </h2>

          <p className="max-w-3xl mx-auto mt-8 text-gray-600 leading-8">

            We believe skincare should feel luxurious yet remain effective.
            Every product is thoughtfully created with clean ingredients,
            dermatologist-inspired research and premium Korean technology.

          </p>

        </div>

      </section>

      {/* Why Choose */}

      <section className="max-w-7xl mx-auto py-28 px-6">

        <h2 className="text-center text-5xl font-heading mb-20">

          Why Choose Celiora

        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

          {[
            {
              icon: <Leaf size={34} />,
              title: "Natural Ingredients",
              text: "Gentle botanical extracts for healthy skin."
            },
            {
              icon: <ShieldCheck size={34} />,
              title: "Dermatologically Tested",
              text: "Safe formulas suitable for daily use."
            },
            {
              icon: <Sparkles size={34} />,
              title: "Korean Innovation",
              text: "Modern skincare backed by research."
            },
            {
              icon: <HeartHandshake size={34} />,
              title: "Cruelty Free",
              text: "Made responsibly with love and care."
            }
          ].map((item, index) => (

            <div
              key={index}
              className="bg-white rounded-3xl p-10 shadow-sm hover:-translate-y-3 duration-500"
            >

              <div className="text-[#9D7D4F]">

                {item.icon}

              </div>

              <h3 className="mt-6 text-xl font-semibold">

                {item.title}

              </h3>

              <p className="mt-4 text-gray-600 leading-7">

                {item.text}

              </p>

            </div>

          ))}

        </div>

      </section>

      {/* CTA */}

      <section className="bg-[#eee4dd] py-24">

        <div className="max-w-5xl mx-auto text-center text-black px-6">

          <h2 className="font-heading text-5xl">

            Discover The Future
            Of Skincare.

          </h2>

          <p className="mt-8 text-black/70 leading-8">

            Join thousands who trust Celiora for healthy,
            radiant and glowing skin every day.

          </p>

          <button className="mt-10 px-10 py-4 bg-[#D8B67D] text-black rounded-full hover:scale-105 duration-300">

            Explore Collection

          </button>

        </div>

      </section>

    </section>
  );
};

export default AboutCeliora;